import React, { useEffect, useState } from "react";
import { Divider, Dropdown } from "antd";
import { useAuth } from "@/context/AuthContext";
import Icon from "@/components/Icon";
import { useNavigate, Link } from "react-router-dom";
import { useMenu } from "@/context/MenuContext";
import { useTranslation } from "react-i18next";

const MenuContent = ({ isDrawer }) => {
    const { getMenu, getFlowMenu } = useAuth();
    const { onMenuClose } = useMenu();
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [flowMenu, setFlowMenu] = useState([]);
    const [menu, setMenu] = useState([]);
    const [isMobile, setIsMobile] = useState(false);

    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    useEffect(() => {
        if (windowSize.width >= 800) {
            setIsMobile(false);
        } else {
            setIsMobile(true);
        }
    }, [windowSize])

    useEffect(() => {
        setFlowMenu(getFlowMenu());
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        let menu1 = getMenu()
        if (menu1) {
            let temp = [];

            menu1.forEach((item, index) => {
                let arr = [];
                item.submenus.forEach((_item, _index) => {
                    arr.push({
                        key: _index,
                        label: <div className={'cursor-pointer'} onClick={() => {
                            onMenuClose();
                            navigate('/admin/' + item.moduleid + '/' + _item.processcode)
                        }}>
                            {i18n.language === 'mn' ? _item.processname : _item.processname2}
                        </div>
                    });
                });
                temp.push({ ...item, items: arr });
            })
            setMenu(temp);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // const onMenuClick = (item) => {
    //     onMenuClose();
    //     navigate('/' + item.moduleid);
    // }

    const getIcon = (moduleid) => {
        switch (moduleid) {
            case 'rp':
                return <Icon name={'FileBarChart2'} size={32} />
            case 'si':
                return <Icon name={'CandlestickChart'} size={32} />
            case 'pf':
                return <Icon name={'Workflow'} size={32} />
            case 'ad':
                return <Icon name={'UserCog'} size={32} />
            case 'gp':
                return <Icon name={'Settings'} size={32} />
            default:
                return <Icon name={'Settings'} size={32} />
        }
    }

    useEffect(() => {
    }, [])

    return (
        <div>
            <div className={'mt-5'}>
                <Divider orientation="left">{t('processes')}</Divider>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-8 gap-8">
                {
                    flowMenu.map((item, index) => {
                        if (item.typeid === 3 || item.typeid === "3") {
                            return (
                                <div key={index} onClick={() => {
                                    onMenuClose();
                                    navigate('/pf/' + item.linkid)
                                }}
                                    className={'bg-[#0881d5] p-4 text-white rounded-xl flex flex-col items-center justify-center cursor-pointer hover:scale-100 transition duration-500'}>
                                    <Icon name={'Table'} size={32} />
                                    <span className={'mt-4 text-center text-base'}>{i18n.language === "mn" ? item.name : item.name2}</span>
                                </div>
                            );
                        }
                        return isMobile ? <Dropdown
                            trigger={['click']}
                            key={index}
                            menu={{
                                items: [
                                    {
                                        key: '1',
                                        label: (
                                            <Link to={'/si/si000201/' + item.linkid} className={'cursor-pointer'} onClick={() => {
                                                onMenuClose();
                                            }}>
                                                {t('list')}
                                            </Link>
                                        ),
                                    },
                                    {
                                        key: '2',
                                        label: (
                                            <Link to={'/si/si000301/' + item.linkid} className={'cursor-pointer'} onClick={() => {
                                                onMenuClose();
                                            }}>
                                                {t('create')}
                                            </Link>
                                        ),
                                    },
                                ]
                            }}>
                            <div
                                className={'bg-[#0881d5] p-4 text-white rounded-xl flex flex-col items-center justify-center cursor-pointer hover:scale-100 transition duration-500'}>
                                <Icon name={'ArrowLeftRight'} size={32} />
                                <span className={'mt-4 text-center text-base'}>{i18n.language === "mn" ? item.name : item.name2}</span>
                            </div>
                        </Dropdown> : <Dropdown
                            key={index}
                            menu={{
                                items: [
                                    {
                                        key: '1',
                                        label: (
                                            <Link to={'/si/si000201/' + item.linkid} className={'cursor-pointer'} onClick={() => {
                                                onMenuClose();
                                            }}>
                                                {t('list')}
                                            </Link>
                                        ),
                                    },
                                    {
                                        key: '2',
                                        label: (
                                            <Link to={'/si/si000301/' + item.linkid} className={'cursor-pointer'} onClick={() => {
                                                onMenuClose();
                                            }}>

                                                {t('create')}
                                            </Link>
                                        ),
                                    },
                                ]
                            }}>
                            <div onClick={() => {
                                onMenuClose();
                                navigate('/si/si000201/' + item.linkid);
                            }}
                                className={'bg-[#0881d5] p-4 text-white rounded-xl flex flex-col items-center justify-center cursor-pointer hover:scale-100 transition duration-500'}>
                                <Icon name={'ArrowLeftRight'} size={32} />
                                <span className={'mt-4 text-center text-base'}>{i18n.language === "mn" ? item.name : item.name2}</span>
                            </div>
                        </Dropdown>
                    })
                }
            </div>
            {
                (menu ?? []).length > 0 && <div className={'mt-10'}>
                    <Divider orientation="left">{t('admin')}</Divider>
                </div>
            }
            <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-8 gap-8">
                {
                    menu.map((item, index) => {
                        return isMobile ? <Dropdown
                            trigger={['click']}
                            key={index}
                            menu={{
                                items: item.items
                            }}>
                            <div
                                className={'bg-[#0881d5] p-4 text-white rounded-xl flex flex-col items-center justify-center cursor-pointer hover:scale-100 transition duration-500'}>
                                {getIcon(item.moduleid)}
                                <span className={'mt-4 text-center text-base'}>{i18n.language === "mn" ? item.name : item.name2}</span>
                            </div>
                        </Dropdown> : <Dropdown
                            key={index}
                            menu={{
                                items: item.items
                            }}>
                            <div onClick={() => {
                                onMenuClose();
                                navigate('/admin/' + item.moduleid);
                            }}
                                className={'bg-[#0881d5] p-4 text-white rounded-xl flex flex-col items-center justify-center cursor-pointer hover:scale-100 transition duration-500'}>
                                {getIcon(item.moduleid)}
                                <span className={'mt-4 text-center text-base'}>{i18n.language === "mn" ? item.name : item.name2}</span>
                            </div>
                        </Dropdown>
                    })
                }
            </div>
            <div className={'mt-10'}>
                <Divider orientation="left">{t('other')}</Divider>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-8 gap-8">
                <div className={'bg-[#0881d5] p-4 text-white rounded-xl flex flex-col items-center justify-center cursor-pointer'}
                >
                    <div
                        onClick={() => {
                            onMenuClose();
                            navigate('/');
                        }}
                        className={'hover:scale-110 transition duration-500 flex flex-col items-center justify-items-center'}>
                        <Icon name={'LayoutDashboard'} size={32} />
                        <span className={'mt-4 text-center text-base'}>{t('dashboard')}</span>
                    </div>
                </div>
                <div className={'bg-[#0881d5] p-4 text-white rounded-xl flex flex-col items-center justify-center cursor-pointer'}
                >
                    <div
                        onClick={() => {
                            onMenuClose();
                            navigate('/rp');
                        }}
                        className={'hover:scale-110 transition duration-500 flex flex-col items-center justify-items-center'}>
                        <Icon name={'ClipboardList'} size={32} />
                        <span className={'mt-4 text-center text-base'}>{t('report')}</span>
                    </div>
                </div>
                <div className={'bg-[#0881d5] p-4 text-white rounded-xl flex flex-col items-center justify-center cursor-pointer'}
                >
                    <div
                        onClick={() => {
                            onMenuClose();
                            navigate('/profile');
                        }}
                        className={'hover:scale-110 transition duration-500 flex flex-col items-center justify-items-center'}>
                        <Icon name={'User'} size={32} />
                        <span className={'mt-4 text-center text-base'}>{t('myInformation')}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MenuContent;
